// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"502":"dec4c112","3669":"67a1c7a7","7618":"7965ae98"}[chunkId] + ".chunk.css";
};